/*!

=========================================================
* Light Bootstrap Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";
import "./assets/css/demo.css";
import "./assets/css/app.css";
import "./assets/css/pe-icon-7-stroke.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import AdminLayout from "layouts/Admin.jsx";
import CustomerLayout from "layouts/Customer.jsx";
import qs from "query-string";
import GlobalState from "context/GlobalState";
import errorLogger from "errorLogger";

import {
  faSpinner,
  faRedo,
  faUndo,
  faSync,
  faCameraRetro,
  faEye,
  faTrashAlt,
  faEdit,
  faItalic,
  faClipboardList,
  faNetworkWired,
  faMapMarkedAlt,
  faHome,
  faDirections
} from "@fortawesome/free-solid-svg-icons";

library.add([
  faSpinner,
  faRedo,
  faUndo,
  faSync,
  faCameraRetro,
  faEye,
  faTrashAlt,
  faEdit,
  faItalic,
  faClipboardList,
  faNetworkWired,
  faMapMarkedAlt,
  faHome,
  faDirections
]);

const sessionId = qs.parse(window.location.search, { ignoreQueryPrefix: true }).sessionId;
const error = qs.parse(window.location.search, { ignoreQueryPrefix: true }).errorMsg;

errorLogger.addLogging();

if (error){
  ReactDOM.render(
    <div>{error}</div>,
    document.getElementById("root")
  );
}
else if (!sessionId) {
  ReactDOM.render(
    <div>Session not found. SessionId must be included in the query string</div>,
    document.getElementById("root")
  );
}
else {
  ReactDOM.render(
    <GlobalState sessionId={sessionId} >
      <CustomerLayout ></CustomerLayout>
    </GlobalState>
    ,
    document.getElementById("root")
  );
}